class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.itemsContainer = document.getElementById('cart-drawer-items');
    this.countEl = document.getElementById('cart-drawer-count');

    // Solo cerrar con el botón X
    document.querySelector('.cart-drawer__close')
      .addEventListener('click', () => this.close());

    this.hiddenQuickAddOverlays = [];
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  open() {
    this.scrollPosition = window.scrollY;

    // DESKTOP → bloquea totalmente
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add('cart-drawer-open');

    this.hiddenQuickAddOverlays = Array.from(document.querySelectorAll('.quick-add-overlay-greener'));
    this.hiddenQuickAddOverlays.forEach((overlayEl) => {
      overlayEl.dataset.prevDisplay = overlayEl.style.display || '';
      overlayEl.style.display = 'none';
    });

    this.drawer.classList.add('open');
    this.overlay.classList.add('active');
  }

  close() {
    this.drawer.classList.remove('open');
    this.overlay.classList.remove('active');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.classList.remove('cart-drawer-open');

    this.hiddenQuickAddOverlays.forEach((overlayEl) => {
      overlayEl.style.display = overlayEl.dataset.prevDisplay || '';
      delete overlayEl.dataset.prevDisplay;
    });
    this.hiddenQuickAddOverlays = [];

    window.scrollTo(0, this.scrollPosition);
  }

  async updateHeaderCartIcon() {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return;

    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
      const iconMarkup = await response.text();
      cartIconBubble.innerHTML = iconMarkup;
    } catch (error) {
      console.error('Error updating cart icon bubble:', error);
    }
  }

  renderCart(cart) {
    document.getElementById('cart-drawer-total').innerHTML = `Subtotal: ${(cart.total_price / 100).toFixed(2)} €`;

    updateFreeShippingMessage(cart);

    this.itemsContainer.innerHTML = '';
    this.countEl.textContent = cart.item_count;

    // FIX: asegurar que siempre existe un array
    const items = cart.items || [];

    items.forEach(item => {
      const div = document.createElement('div');
      div.className = 'cart-drawer-item';
      div.innerHTML = `
        <img src="${item.image}" alt="${item.title}">
        <div class="cart-drawer-item__info">
          <p>${item.product_title}</p>
          ${item.variant_title ? `<small>Talla: ${item.variant_title}</small>` : ''}
          <small>Cant: ${item.quantity}</small>
          <strong>${(item.final_line_price / 100).toFixed(2)} €</strong>
        </div>
        <cart-remove-button-notification data-key="${item.key}">
        <a href="#" 
          class="button button--tertiary cart-drawer-remove"
          data-key="${item.key}"
          aria-label="Eliminar ${item.product_title}">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" 
            aria-hidden="true" focusable="false" role="presentation" 
            class="icon icon-remove cart-drawer-remove-icon">
            <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
            <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
          </svg>
        </a>
        </cart-remove-button-notification>
      `;

      this.itemsContainer.appendChild(div);
    });

    this.updateHeaderCartIcon();
  }


  async update() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    this.renderCart(cart);
    this.open();
  }
}

customElements.define('cart-notification', CartNotification);

class CartRemoveButtonNotification extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(evt) {
    evt.preventDefault();

    const key = this.dataset.key || this.querySelector('a').dataset.key;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(res => res.json())
    .then(cart => {
      document.querySelector('cart-notification').renderCart(cart);
    })
    .catch(err => console.error(err));
  }
}

customElements.define('cart-remove-button-notification', CartRemoveButtonNotification);

document.addEventListener('click', (event) => {
  const overlay = document.querySelector('.cart-drawer-overlay');
  const drawer = document.getElementById('cart-drawer');

  // Si el clic NO es en el overlay, no hacemos nada
  if (event.target !== overlay) return;

  // Si el clic es en el overlay, cerramos
  document.querySelector('cart-notification').close();
});

document.addEventListener('click', (event) => {
  const btn = event.target.closest('.cart_continue');
  if (!btn) return;

  event.preventDefault(); // evita navegar a "/"
  document.querySelector('cart-notification').close();
});


/* Get shipping info for each location */
window.getShippingInfo = function (info) {
  const shipping_countries = {
      "AT": {
          "province": "Vienna",
          "zip": "1010",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "BE": {
          "province": "Brussels",
          "zip": "1000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "4",
          "delivery_time_end": "5",
      },
      "BG": {
          "province": "Sofia",
          "zip": "1000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "HR": {
          "province": "Zagreb",
          "zip": "10110",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "CZ": {
          "province": "Prague",
          "zip": "16000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "DK": {
          "province": "Copenhagen",
          "zip": "1000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "EE": {
          "province": "Tallinn",
          "zip": "10118",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "FI": {
          "province": "Helsinki",
          "zip": "00100",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "FR": {
          "province": "Paris",
          "zip": "75001",
          "free_shipping_threshold": "119",
          "delivery_time_start": "2",
          "delivery_time_end": "3",
      },
      "DE": {
          "province": "Berlin",
          "zip": "10115",
          "free_shipping_threshold": "119",
          "delivery_time_start": "2",
          "delivery_time_end": "3",
      },
      "GR": {
          "province": "Athens",
          "zip": "10431",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "HU": {
          "province": "Budapest",
          "zip": "1007",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "IE": {
          "province": "Dublin",
          "zip": "D06N1F1",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "IT": {
          "province": "Roma",
          "zip": "00042",
          "free_shipping_threshold": "119",
          "delivery_time_start": "2",
          "delivery_time_end": "3",
      },
      "LV": {
          "province": "Riga",
          "zip": "1000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "LT": {
          "province": "Vilna",
          "zip": "01100",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "LU": {
          "province": "Luxembourg",
          "zip": "1111",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "NL": {
          "province": "Amsterdam",
          "zip": "1011BC",
          "free_shipping_threshold": "119",
          "delivery_time_start": "3",
          "delivery_time_end": "5",
      },
      "NO": {
          "province": "Oslo",
          "zip": "0050",
          "free_shipping_threshold": "169",
          "delivery_time_start": "2",
          "delivery_time_end": "3",
      },
      "PL": {
          "province": "Warsaw",
          "zip": "00006",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "PT": {
          "province": "Lisboa",
          "zip": "1000",
          "free_shipping_threshold": "7.60",
          "delivery_time_start": "2",
          "delivery_time_end": "3",
      },
      "RO": {
          "province": "Arad",
          "zip": "310010",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "SK": {
          "province": "Brastilava",
          "zip": "02412",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "SI": {
          "province": "Ljubiana",
          "zip": "1000",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "SE": {
          "province": "Stockholm",
          "zip": "10316",
          "free_shipping_threshold": "119",
          "delivery_time_start": "5",
          "delivery_time_end": "8",
      },
      "ES": {
          "province": "Madrid",
          "zip": "28028",
          //"free_shipping_threshold": "0",
          "free_shipping_threshold": "49",
          "delivery_time_start": "1",
          "delivery_time_end": "3",
      }
  };

  return fetch("https://greenerwear.eu/browsing_context_suggestions.json")
    .then(res => res.json())
    .then(data => {
      const countryCode = data?.detected_values?.country?.handle || "ES";
      return Number(shipping_countries[countryCode]?.[info] || 0);
    })
    .catch(() => Number(shipping_countries["ES"]?.[info] || 0));
}

async function updateFreeShippingMessage(cart) {
  const messageEl = document.getElementById('cart-free-shipping-message');
  if (!messageEl) return;

  const threshold = await getShippingInfo('free_shipping_threshold');
  if (!threshold) {
    messageEl.innerHTML = '';
    return;
  }

  const cartTotal = cart.total_price / 100;
  const remaining = threshold - cartTotal;

  if (remaining > 0) {
    messageEl.innerHTML = `
      <p>
        Te faltan <strong>${remaining.toFixed(2)} €</strong> 
        para conseguir <strong>envío gratuito</strong>
      </p>
    `;
  } else {
    messageEl.innerHTML = `
      <p class="free-shipping-success">
        <strong>¡Has conseguido el envío gratuito!</strong>
      </p>
    `;
  }
}
